/* eslint-disable */
import * as d3 from 'd3';

// const MAX = 999.0;
const MAX_RADIUS_F = 0.8;
const MIN_RADIUS_F = 0.20;
const TICK = 4;

function donut(options) {
  const { max, overall, focusedKey } = options || {};

  const color = (datum) => {
    if (!datum) {
      return '#444444'
    };
    if (focusedKey && datum.key !== focusedKey) {
      return '#c6c6c6'; // disabled
    }
    if (datum.color) {
      return datum.color;
    } else {
      d3.scaleOrdinal(d3.schemeCategory10)[datum.label];
    }
  };

  // set same value to make each segment same anger range
  const pie = d3.pie()
    .sort(null)
    .value(1); // .value(d => d.value) for dynamic width

  // Default settings
  let containerElement = d3.select('body');
  let data = [];
  let width = 900;
  let height = 400;
  let radius = Math.min(width, height) * 0.6;
  const maxRadius = radius * MAX_RADIUS_F;
  const minRadius = radius * MIN_RADIUS_F;

  const getFocusedDatum = () => data.find(datum => datum.key === focusedKey);
  const getFocusedValue = () => {
    const datum = data.find(datum => datum.key === focusedKey);
    const value = datum?.value || 0;
    return value < 0 ? 'N/A' : value;
  };
  // Set each arc different outerRadius based on the its value
  const dynamicArc = (value) => {
    const minOuterRadius = minRadius + 0.1 * (maxRadius - minRadius);
    const outerRadius = minRadius + value / max * (maxRadius - minRadius);
    return d3.arc().outerRadius(d3.max([outerRadius, minOuterRadius])).innerRadius(minRadius);
  };

  let svg, g, arc, outerArc;

  let object = {};

  // Method for render/refresh graph
  object.render = function(onClick) {
    const segmentAngle = data.length > 0 ? 360.0 / data.length : 360;
    if (!svg) {
      const r = d3.scaleLinear()
        .domain([0, max])
        .range([minRadius, maxRadius]);

      // virtuel inner circle to align polylines
      arc = d3.arc()
        .outerRadius(radius * 0.6)
        .innerRadius(radius * 0.4);

      // virtual outer circles to align the polylines
      outerArc = d3.arc()
        .innerRadius(radius * 0.9)
        .outerRadius(radius * 0.9);

      svg = containerElement.append('svg')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', `translate(${width / 2}, ${ height / 2})`);

      // Add pie chart background
      svg.append("g")
        .attr('class', 'bg')
        .append("circle")
        .attr("r", maxRadius)
        .style('fill', '#e8e7e6');
      svg.append("g")
        .attr('class', 'bg')
        .append("circle")
        .attr("r", minRadius)
        .style('fill', 'white');

      // Add segment containers with dynamic outer radius
      g = svg.selectAll('.arc')
        .data(pie(data))
        .enter().append('g')
        .attr('class', 'arc');

      g.append('path')
        .attr('d', (d, i) => dynamicArc(d.data.value)(d, i))
        .style('fill', d => color(d.data));

      // Add segment border, e.g. draw a line each 60 degree
      const ga = svg.append("g")
        .attr("class", "a axis")
        .selectAll("g")
        .data(d3.range(90, 450, segmentAngle))
        .enter().append("g")
        .attr("transform", function(d) { return "rotate(" + -d + ")"; })
        .style('stroke', 'white')
        .append("line")
        .attr("x1", minRadius)
        .attr("x2", maxRadius);

      // Add circle axis tick 5
      const gr = svg.append("g")
        .attr("class", "r axis")
        .selectAll("g.axis")
        .data(r.ticks(TICK).slice(1))
        .enter().append("g");

      gr.append("circle")
        .attr("r", r)
        .style('fill', 'none')
        .style('stroke', 'white')
        .style('z-index', 1000);

      gr.append("text")
        .attr("y", function(d) { return -r(d) - 4; })
        .style("text-anchor", "middle")
        .text(function(d) { return d; });

      svg.append('text')
        .text(focusedKey ? 'Score' : 'Total score')
        .attr('x', 0)
        .attr('y', -10)
        .attr('class', 'overall-score')
        .style('text-anchor', 'middle')
        .attr('font-weight', 'bold')
        .style('font-size', '13px')
        .style('fill', color(getFocusedDatum()));

      svg.append('text')
        .text((focusedKey ? getFocusedValue() : overall) ?? '0')
        .attr('x', 0)
        .attr('y', 20)
        .attr('class', 'overall-score')
        .style('text-anchor', 'middle')
        .attr('font-weight', 'bold')
        .style('font-size', '30px')
        .style('fill', color(getFocusedDatum()));

      // Add Mouseover text container
      svg.append('text')
        .datum(data)
        .attr('x', 0 )
        .attr('y', 0 + radius )
        .attr('class', 'text-tooltip')
        .style('text-anchor', 'middle')
        .attr('font-weight', 'bold')
        .style('font-size', '16px');

      g.on('click', function(event, obj) {
        // TODO: hightlight the group value
        onClick && onClick(obj.data.key);
        // svg.select('text.text-tooltip')
        //  .attr('fill', color(obj.data))
        //  .text(`${obj.data.label}: ${obj.data.value}`);
      });

      g.on('mouseout', function () {
        // TODO: mouseout effect
        // svg.select('text.text-tooltip').text('');
      });

      // Add polylines to point to data.key text, aligned by outerArc
      svg
        .selectAll('allPolylines')
        .data(pie(data))
        .enter()
        .append('polyline')
        .attr('stroke', d => color(d.data))
        .style('fill', 'none')
        .attr('stroke-width', 1)
        .attr('points', function(d) {
          const posA = arc.centroid(d); // line insertion in the slice
          const posB = outerArc.centroid(d); // line break: we use the other arc generator that has been built only for that
          const posC = outerArc.centroid(d); // Label position = almost the same as posB
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2; // we need the angle to see if the X position will be at the extreme right or extreme left
          posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
          return [posA, posB, posC];
        });

      // Add the polylines between chart and labels:
      svg
        .selectAll('allLabels')
        .data(pie(data))
        .enter()
        .append('text')
        .text( function(d) {
          const value = d.data.value < 0 ? 'N/A' : d.data.value;
          if (d.startAngle < 3.14) { // right
            return `${d.data.label} ${value}`
          } else { // left
            return `${value} ${d.data.label}`
          }
          return d.data.label;
        })
        .attr('transform', function(d) {
          const pos = outerArc.centroid(d);
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1);
          return 'translate(' + pos + ')';
        })
        .style('text-anchor', function(d) {
          const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          return (midangle < Math.PI ? 'start' : 'end');
        })
        .style('fill', d => color(d.data));
    } else {
      g.data(pie(data)).exit().remove();

      g.select('path')
        .transition().duration(200)
        .attrTween('d', function(a){
          let i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function(t) {
            return arc(i(t));
          };
        });

      g.select('text')
        .attr('transform', function(d) { return `translate(${arc.centroid(d)})`; });

      svg.select('text.text-tooltip').datum(data);
    }
    return object;
  };

  // Getter and setter methods
  object.data = function(value){
    if (!arguments.length) return data;
    data = value;
    return object;
  };

  object.containerElement = function(value){
    if (!arguments.length) return containerElement;
    containerElement = value;
    return object;
  };

  object.width = function(value){
    if (!arguments.length) return width;
    width = value;
    radius = Math.min(width, height) / 2;
    return object;
  };

  object.height = function(value){
    if (!arguments.length) return height;
    height = value;
    radius = Math.min(width, height) / 2;
    return object;
  };

  return object;
}

export default function drawDonutChart(el, data, options, onClick) {
  const { width = 900, height = 500 } = options || {};
  donut(options || {})
    .containerElement(el)
    .width(width)
    .height(height)
    .data(data)
    .render(onClick);
}
